<template>
  <ClientsForm :client="client" :onSubmit="submit"></ClientsForm>
</template>

<script>
import ClientsForm from './Clients-Form.vue';
import { busEvent } from '../../main';

export default {
  name: 'edit-clients',
  components: {
    ClientsForm,
  },
  created() {
    this.$store.dispatch('clients/getClient', this.$route.params.id);
  },
  computed: {
    client() {
      return this.$store.state.clients.client;
    },
  },
  methods: {
    submit() {
      this.$store.dispatch('clients/updateClient', { id: this.$route.params.id, body: this.client })
        .then(() => {
          busEvent.$emit('succesPopupCreated', 'Informatie actualizata');
        });
    },
  },
};
</script>
